// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { getUsersImportTemplate, submitUsersCsv } from '@api/portalServices';
import type { ImportFileSubmitRequest, ImportResult } from '@api/types';
import { useMutation, useQuery } from '@tanstack/react-query';
import { extractCsvResponse } from '../modals/importUsersModal/extractCsvResponse/extractCsvResponse';

interface UsersImportMutationResult {
  importResult: ImportResult;
  errorReport?: Blob;
}

export const useUsersImportTemplate = (tenantId: string) => {
  return useQuery<Blob>({
    queryKey: ['users-import-template'],
    queryFn: () => getUsersImportTemplate(tenantId),
    enabled: false,
  });
};

export const useSubmitUsersCsv = (tenantId: string) => {
  return useMutation<UsersImportMutationResult, Error, ImportFileSubmitRequest>({
    mutationFn: async request => {
      const response = await submitUsersCsv(request, tenantId);
      return extractCsvResponse(response);
    },
  });
};
